import React, { useEffect } from "react";
import "../styles/Home.css";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { Link } from "react-router-dom";

export default function Home({ setProvince }) {
  const theme = createTheme({
    palette: {
      primary: {
        main: "#506CAA",
        dark: "#506CAA",
      },
      text: {
        primary: "#31303F",
        secondary: "#506CAA",
      },
    },
  });

  const changeProvince = (e) => {
    setProvince(e.target.value);
  };

  useEffect(() => {
    setProvince("");
  });

  return (
    <div>
      <div className="home flex flex-col items-center jusity-center w-full ">
        <div className="home-title"></div>

        <div className="flex flex-col items-left mt-2">
          <ThemeProvider theme={theme}>
            <FormControl sx={{ mt: 1, minWidth: 325, maxWidth: 110 }}>
              <InputLabel size="small" className="select-default-label">
                Select Province
              </InputLabel>
              <Select
                value=""
                name="Select Province"
                label="Select Province"
                onChange={changeProvince}
                size="small"
                sx={{ borderRadius: 20 }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      "& .MuiMenuItem-root": {
                        "&:hover": {
                          backgroundColor: "rgba(0, 0, 0, 0.04) !important",
                        },
                        "&.Mui-focusVisible": {
                          backgroundColor: "transparent !important",
                        },
                        "&.Mui-selected": {
                          backgroundColor: "transparent !important",
                        },
                        "&.Mui-selected:hover": {
                          backgroundColor: "rgba(0, 0, 0, 0.04) !important",
                        },
                      },
                    },
                  },
                }}
              >
                <MenuItem
                  key={Math.random()}
                  value="AB"
                  component={Link}
                  to="/AB"
                >
                  Alberta
                </MenuItem>
                <MenuItem
                  key={Math.random()}
                  value="BC"
                  component={Link}
                  to="/BC"
                >
                  British Columbia
                </MenuItem>
                <MenuItem
                  key={Math.random()}
                  value="ON"
                  component={Link}
                  to="/ON"
                >
                  Ontario
                </MenuItem>
                <MenuItem
                  key={Math.random()}
                  value="YT"
                  component={Link}
                  to="/YT"
                >
                  Yukon
                </MenuItem>
              </Select>
            </FormControl>
          </ThemeProvider>
        </div>
      </div>
    </div>
  );
}

/*

<MenuItem
                  key={Math.random()}
                  value="NB"
                  component={Link}
                  to="/NB"
                >
                  New Brunswick
                </MenuItem>
                <MenuItem
                  key={Math.random()}
                  value="MB"
                  component={Link}
                  to="/MB"
                >
                  Manitoba
                </MenuItem>
                <MenuItem
                  key={Math.random()}
                  value="SK"
                  component={Link}
                  to="/SK"
                >
                  Saskatchewan
                </MenuItem>
                <MenuItem
                  key={Math.random()}
                  value="QC"
                  component={Link}
                  to="/QC"
                >
                  Quebec
                </MenuItem>

*/
